import { ILoginSSORequestModel } from "../../models/request/account/index"
import { IUserInfoModel } from "../../models/response/account/user-info";
export enum AccountActionTypeIds {
    LOGIN_START = "LOGIN_START",
    LOGIN_SUCCESS = "LOGIN_SUCCESS",
    LOGIN_ERROR = "LOGIN_ERROR",
    LOG_OUT = "LOG_OUT",
}
export interface ILoginStartAction {
    type: AccountActionTypeIds.LOGIN_START,
    payload: ILoginSSORequestModel
}
export interface ILoginSuccessAction {
    type: AccountActionTypeIds.LOGIN_SUCCESS,
}
export interface ILoginErrorAction {
    type: AccountActionTypeIds.LOGIN_ERROR,
    payload?: string
}
export interface ILogOutAction {
    type: AccountActionTypeIds.LOG_OUT,
}

export type AccountActionTypes = ILoginStartAction | ILoginSuccessAction | ILoginErrorAction | ILogOutAction